import React, { useState } from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import ButtonBase from "../../Buttons/ButtonBase";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { validationQuestions, validationDummy } from '../../../utils/validations';
import { ESPECIALIDADITEMS } from '../../../utils/ConstantsMain';
import { TextField } from '@material-ui/core';
import { createQuestions } from "../../../configs/environments/firebase/firebaseApp";
import Snackbar from '../../Snackbar';
import { isMobile } from 'react-device-detect';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { pagingQuestion, moreQuestion, setCommunityKey, pagingAllQuestions } from "../../../store/actions/CommunityAction";
import ModalSignIn from "../../Modal/ModalSignIn/ModalSignIn";
import "./createquestion.scss";
// import categories from "../categories.json";

const useStyles = makeStyles(theme => ({

    inputLabelRoot: {
        transform: 'translate(14px, 16px) scale(1)',
    },
    formHelperTextRoot: {
        margin: '8px 14px',
        marginBottom: 0,
    },
    inputError: {
        border: '1px solid #d74242',
        '&:hover': {
            border: '1px solid #d74242',
        },
    },
    TextField: {
        maxWidth: '576px',
    },
    TextField_small: {
        maxWidth: '46%',
    },
}));

const CreateQuestionForm = (props) => {
    const { laywerUid, isLawyer, role, setCommunityKey, pagingAllQuestions } = props
    const classes = useStyles();
    const history = useHistory();
    const [feedbackMessage, setFeedbackMessage] = useState({
        open: false,
        message: '',
        variant: 'success'
    });
    
    let noAuth = true
    if (role && role === 'cliente') {
        noAuth = false
    }
    
    const [topicData, setTopicData] = useState();

    const formQuestionsValues = {
        title: "",
        topic: "",
        details: "",
    };

    const handleCloseFeedbackMessage = () => {
        setFeedbackMessage({
            open: false,
            message: '',
            variant: 'success'
        });
    };

    const handleSubmitQuestionForm = async (values, { setSubmitting, setFieldError, resetForm }) => {

        setSubmitting(false)
        showLoading()
        let body = {
            createdBy: laywerUid,
            ...values
        }
        let response = await createQuestions(body);
        if (response.status === "successful") {
            hideLoading();
            setFeedbackMessage({
                open: true,
                message: 'Tu pregunta se ha publicado con éxito.',
                variant: 'success'
            });
            await pagingAllQuestions(1)
            setCommunityKey('')
            moreQuestion()
            resetForm()
        }

    }

    const [ openLogin, setOpenLogin ] = useState(false)

    const handleLoginModal = () => {
        setOpenLogin(!openLogin)
    }

    const selectTopicQuestion = (params) => {
        setTopicData(params)
    }

    const handleRenderForm = (props) => {

        const { handleChange, handleSubmit, values, touched, errors, handleBlur, isValid } = props;
        values.topic = topicData
        
        return (
            <div className="contentMainQuestionForm">
                <div className="contentTitle">
                    <p className="titleCreateQuestion"> Cuéntale tu caso a nuestra comunidad de abogados, expertos en el área podrán asesorarte en temas legales en menos de 24 horas. </p>
                </div>
                <form>
                    <div className="contentInputsQuestions">
                        <TextField
                            label="Título de tu pregunta*"
                            name="title"
                            type="text"
                            variant="outlined"
                            onBlur={handleBlur}
                            value={values.title}
                            onChange={noAuth ? handleLoginModal : handleChange}
                            helperText={
                                touched.title && errors.title && !noAuth ? errors.title : ''
                            }
                            error={touched.title && errors.title && !noAuth ? true : false}
                            fullWidth
                            classes={{ root: classes.TextField }}
                        />
                        <Autocomplete
                            name="topic"
                            options={ESPECIALIDADITEMS}
                            getOptionLabel={option => option}
                            classes={{ root: classes.TextField }}
                            onChange={(event, value) => {
                                if (noAuth) {
                                    handleLoginModal()
                                } else {
                                    selectTopicQuestion(value);
                                }
                            }}
                            renderInput={params =>
                                <TextField
                                    {...params}
                                    value={topicData}
                                    classes={{ root: classes.TextField }}
                                    label="Selecciona un tema*"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                />}
                        />

                        <TextField
                            label="Detalles sobre tu pregunta legal*"
                            type="text"
                            name="details"
                            variant="outlined"
                            multiline={true}
                            rows="4"
                            style={{ height: 'auto' }}
                            classes={{ root: classes.TextField }}
                            onBlur={handleBlur}
                            onChange={noAuth ? handleLoginModal : handleChange}
                            value={values.details}
                            helperText={
                                touched.details && errors.details && !noAuth ? errors.details : ''
                            }
                            error={touched.details && errors.details && !noAuth ? true : false}
                        />
                    </div>
                    <div className="contentButtonPostQuestion">
                        <ButtonBase
                            type="submit"
                            onClick={handleSubmit}
                            className="postQuestion"
                            variant="primary"
                            disabled={!isValid}
                        >
                            Publicar pregunta
                        </ButtonBase>
                        <p className="textRequest">Los campos marcados con * son obligatorios</p>
                    </div>
                </form>
            </div>
        )
    }

    return (
        <>
            <Formik
                initialValues={formQuestionsValues}
                validationSchema={validationQuestions}
                onSubmit={handleSubmitQuestionForm}
                render={handleRenderForm}
            />
            <Snackbar
                open={feedbackMessage.open}
                message={feedbackMessage.message}
                variant={feedbackMessage.variant}
                handleClose={handleCloseFeedbackMessage}
                vertical="top"
                horizontal="right"
                snackbarTop={isMobile ? '70px' : '80px'}
            />
            <ModalSignIn
                open={openLogin}
                handleClose={handleLoginModal}
            />
        </>
    );
}

const mapDispatchToProps = dispatch => ({
    pagingAllQuestions: page => dispatch(pagingAllQuestions(page)),
    pagingQuestion: (search, page) => dispatch(pagingQuestion(search, page)),
    setCommunityKey: key => dispatch(setCommunityKey(key)),
    moreQuestion: () => dispatch(moreQuestion()),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading())
})

const mapStateToProps = (state) => ({
    laywerUid: state.authClient.uid,
    role: state.authClient.role
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateQuestionForm);
